import { PAYMENTS_ENDPOINTS } from '~/config/constants';
import { SGApi } from './axios';

export function getPricingPayment(sessionId: string) {
  const _endpoint = PAYMENTS_ENDPOINTS.pricing(sessionId);

  return SGApi.get(_endpoint);
}
